var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.46875 1.375V17.7813C3.46875 18.6515 3.81445 19.4861 4.42981 20.1014C5.04516 20.7168 5.87976 21.0625 6.75 21.0625H10.0313M3.46875 1.375H1.28125M3.46875 1.375H27.5313M10.0313 21.0625H20.9688M10.0313 21.0625L8.57292 25.4375M27.5313 1.375H29.7188M27.5313 1.375V17.7813C27.5313 18.6515 27.1855 19.4861 26.5702 20.1014C25.9548 20.7168 25.1202 21.0625 24.25 21.0625H20.9688M20.9688 21.0625L22.4271 25.4375M8.57292 25.4375H22.4271M8.57292 25.4375L7.84375 27.625M22.4271 25.4375L23.1563 27.625M11.125 13.4063V15.5938M15.5 10.125V15.5938M19.875 6.84375V15.5938",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector3);
export default __webpack_public_path__ + "static/media/Vector (3).5f3b7e461818268ffea045d4b80e5c78.svg";
export { ForwardRef as ReactComponent };